module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textArea"
  }, [_c('textarea', {
    style: ({
      height: _vm.height
    }),
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.input($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.value == "") ? _c('span', [_vm._v(_vm._s(_vm.hitMsg))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-481fd24a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/inputArea.vue
// module id = 1488
// module chunks = 18